import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const ItemsSubitems = ({ selectedItem, closeMenu, handleBackButtonItemsSubitems }) => {
  const reloadScreen = () => {
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }

  useEffect(() => {
    document.getElementById('voltar_subitem').focus()
  })

  return (
    <div className='subMenuToggle active'>
      <ul className='txt-left radius px-0 py-0' tabIndex={-1}>
        <li className='close-hamburger-menu bg-brand-4 color-ui-white px-2 py-0 mb-1'>
          <a
            id='voltar_subitem'
            onClick={() => handleBackButtonItemsSubitems()}
            onKeyPress={() => handleBackButtonItemsSubitems()}
            className='link-font-mobile mn-item color-ui-white d-flex align-items-center h-100'
            tabIndex={0}
            aria-label='Voltar'
          >
            <i className='icon icon_left_app color-ui-white mr-1' aria-hidden='true' />
            Voltar
          </a>
        </li>
        {selectedItem.items.map((item, index) => {
          return (<li className='px-1 py-0 border-color-brand-5 h-100 item-menu-mobile' key={`item_subitem_${index}`}>
            <div className='row'>
              <div className='col-12 px-0' onClick={() => closeMenu()}>
                <Link
                  className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'
                  to={item.path}
                  aria-label={item.label}
                  onClick={() => reloadScreen()}
                >
                  <div className='row align-items-center h-100 pos-relative'>
                    <div className='col ml-2 py-half' aria-hidden>{item.label}</div>
                  </div>
                </Link>
              </div>
            </div>
          </li>)
        })}
      </ul>
    </div>
  )
}

ItemsSubitems.propTypes = {
  selectedItem: PropTypes.object.isRequired,
  closeMenu: PropTypes.func.isRequired,
  handleBackButtonItemsSubitems: PropTypes.func.isRequired
}

export default ItemsSubitems



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/SubItems/ItemsSubitems.js